import type { ModuleManifest } from "./types";

export const opportunitiesManifest: ModuleManifest = {
  name: "opportunities",
  label: "Opportunity",
  labelPlural: "Opportunities",

  coreBOSModule: "Potentials",
  wsidPrefix: "13x",

  type: "standard",

  routes: {
    list: "/opportunities",
    show: "/opportunities/show/:id",
    create: "/opportunities/create",
    edit: "/opportunities/edit/:id",
  },

  navigation: {
    icon: "TrophyOutlined",
    order: 5,
    group: "CRM",
  },

  routing: {
    keywords: [
      "opportunity",
      "opportunities",
      "deal",
      "deals",
      "potential",
      "potentials",
      "pipeline",
      "sales",
    ],
    searchFields: ["potentialname", "sales_stage"],
    defaultSort: { field: "closingdate", order: "asc" },
  },

  context: {
    supported: true,
    entityKey: "opportunities",
  },

  fields: [
    {
      name: "potentialname",
      label: "Opportunity Name",
      type: "string",
      required: true,
    },
    {
      name: "related_account",
      label: "Account",
      type: "reference",
      referenceModule: "Accounts",
    },
    {
      name: "related_to",
      label: "Contact",
      type: "reference",
      referenceModule: "Contacts",
    },
    {
      name: "sales_stage",
      label: "Stage",
      type: "picklist",
      required: true,
      options: [
        { value: "Prospecting", label: "Prospecting" },
        { value: "Qualification", label: "Qualification" },
        { value: "Needs Analysis", label: "Needs Analysis" },
        { value: "Value Proposition", label: "Value Proposition" },
        { value: "Negotiation", label: "Negotiation" },
        { value: "Closed Won", label: "Closed Won" },
        { value: "Closed Lost", label: "Closed Lost" },
      ],
    },
    { name: "amount", label: "Amount", type: "currency" },
    { name: "probability", label: "Probability (%)", type: "number" },
    { name: "closingdate", label: "Close Date", type: "date", required: true },
    { name: "leadsource", label: "Lead Source", type: "picklist" },
    {
      name: "opportunity_type",
      label: "Type",
      type: "picklist",
      options: [
        { value: "Existing Business", label: "Existing Business" },
        { value: "New Business", label: "New Business" },
      ],
    },
    { name: "nextstep", label: "Next Step", type: "string" },
    { name: "description", label: "Description", type: "text" },
    {
      name: "assigned_user_id",
      label: "Assigned To",
      type: "reference",
      referenceModule: "Users",
      hidden: true,
      defaultValue: "19x1",
    },
  ],

  relationships: [
    {
      module: "Accounts",
      field: "related_account",
      label: "Account",
      icon: "BankOutlined",
      displayField: "accountname",
    },
    {
      module: "Contacts",
      field: "related_to",
      label: "Contact",
      icon: "UserOutlined",
      displayField: "lastname",
    },
    {
      module: "Documents",
      relation: "many-to-many",
      label: "Documents",
      icon: "FileOutlined",
      displayField: "notes_title",
    },
  ],

  requiredFields: [
    "potentialname",
    "sales_stage",
    "closingdate",
    "assigned_user_id",
  ],

  // Mass edit - fields are dynamically loaded from filterFields
  massEdit: {
    enabled: true,
  },
};
